import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useAssignee(id: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.assignee(id)],
    queryFn: () => ace_api.getAssignee(api)({ clientID: id }),
    enabled: api.token !== '',
  });
}
